export const tableOptionVoice = {
  dialogDrag:true,
  border: true,
  index: true,
  indexLabel: '序号',
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  editBtn: false,
  delBtn: false,
  addBtn: false,
  viewBtn: true,
  searchMenuSpan: 6,
  column: [
	  {
      label: 'media_id',
      prop: 'mediaId'
    },
	  {
      label: '名称',
      prop: 'name'
    },
	  {
      label: '更新时间',
      prop: 'updateTime'
    }
  ]
}
